/**
 * @file backup-agent-activity.ts
 * @description Вышел ли агент бэкапа снова на связь после экстренного отзыва
 * ключа (phase19.26 шаг 7.1, Р2; TD-161).
 *
 * После отзыва агент продолжает делать локальные копии, но панель его отчёты
 * отклоняет — время последнего отчёта на странице замирает. Как только на
 * сервере заново выполнили команду установки, агент отчитывается новым ключом,
 * и это время сдвигается. Сравниваем серверные отметки между собой (а не
 * с часами браузера): снимок берём по данным, перечитанным сразу после отзыва.
 */

import type { BackupConfigDto, BackupRunDto } from "../../../lib/api-backups";

/** Время в мс или null — нет/не дата. */
function time(iso: string | null | undefined): number | null {
  if (!iso) return null;
  const t = new Date(iso).getTime();
  return Number.isFinite(t) ? t : null;
}

/**
 * Время последнего отчёта агента по данным страницы: замер диска, последний
 * успех, завершение любого этапа в истории (`finishedAt` ставит только отчёт
 * агента; плейсхолдер «Запустить сейчас» его не имеет). null — отчётов не было.
 */
export function agentActivityMark(
  config: Pick<BackupConfigDto, "diskStats" | "lastSuccessAt">,
  runs: ReadonlyArray<Pick<BackupRunDto, "finishedAt">>,
): number | null {
  const marks = [
    time(config.diskStats?.updatedAt),
    time(config.lastSuccessAt),
    ...runs.map((r) => time(r.finishedAt)),
  ].filter((t): t is number => t !== null);
  return marks.length ? Math.max(...marks) : null;
}

/** Агент отчитался позже снимка, сделанного при отзыве ключа. */
export function agentReportedSince(snapshot: number | null, current: number | null): boolean {
  if (current === null) return false;
  return snapshot === null || current > snapshot;
}
